"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTravelAgentRealizedOrdersToTier = transformTravelAgentRealizedOrdersToTier;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformTravelAgentRealizedOrdersToTier(realizedOrdersCount) {
    if (realizedOrdersCount > 20) {
        return legacy_enums_1.TravelAgentTier.Gold;
    }
    if (realizedOrdersCount > 10) {
        return legacy_enums_1.TravelAgentTier.Silver;
    }
    if (realizedOrdersCount > 0) {
        return legacy_enums_1.TravelAgentTier.Bronze;
    }
    return undefined;
}
//# sourceMappingURL=transformTravelAgentRealizedOrdersToTier.js.map